import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { logout as apiLogout } from "@/api/endpoints/auth";
import { useAuthStore } from "@/store/authStore";

export function Topbar({ onOpenCommandPalette }: { onOpenCommandPalette: () => void }) {
  const user = useAuthStore((s) => s.user);
  const clearSession = useAuthStore((s) => s.clearSession);
  const navigate = useNavigate();

  const logoutMutation = useMutation({
    mutationFn: apiLogout,
    onSettled: () => {
      clearSession();
      navigate("/login", { replace: true });
    },
  });

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b border-border bg-surface px-6">
      <button
        onClick={onOpenCommandPalette}
        className="flex items-center gap-2 rounded-md border border-border bg-surface-2 px-3 py-1.5 text-sm text-text-muted hover:border-accent"
      >
        Search everywhere
        <kbd className="rounded border border-border px-1.5 py-0.5 font-mono text-xs">⌘K</kbd>
      </button>

      <div className="flex items-center gap-3">
        {user && (
          <span className="rounded-full bg-surface-2 px-3 py-1 font-mono text-xs uppercase tracking-wide text-accent">
            {user.role}
          </span>
        )}
        <span className="text-sm text-text">{user?.username}</span>
        <button
          onClick={() => logoutMutation.mutate()}
          className="rounded-md px-3 py-1.5 text-sm text-text-muted hover:text-text"
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
